"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectHrefMethod = injectHrefMethod;

var _common = require("../common");

/**
 * @file href 扩展全局函数，用于跳转函数。 $coolHref()
 * @author qiaogang
 * @date 2020-05-15
 */
function injectHrefMethod(vue) {
  if (!vue.prototype.$coolHref) {
    vue.prototype.$coolHref = function (url, options) {
      return (0, _common.coolHref)(url, options);
    };
  }
}